// src/pages/AdsSupport/AdsInquiryHistory.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

import { HeaderIconLR } from "../../assets/components/HeaderGroup";
import { useFixedLayout } from "../../hooks/useFixedLayout";

import left from "../../assets/icons/Arrow/left.svg";
// TODO: 실제 홈 아이콘 경로로 교체
import home from "../../assets/icons/TabBar/home_active.svg";
import chevronUp from "../../assets/icons/Chevron/up_black.svg"
import chevronDown from "../../assets/icons/Chevron/down_black.svg"
import { Bottom } from "../../assets/components/BottomSheetGroup";
import { useToast } from "../../hooks/useToast";

const API = process.env.REACT_APP_UPLOAD_BASE_URL;

const IMAGE_BASE = API + "/uploads";

const PERIOD_OPTIONS = [
  { value: "1m", label: "1개월" },
  { value: "3m", label: "3개월" },
  { value: "6m", label: "6개월" },
];

const TYPE_OPTIONS = [
  { value: "all", label: "전체" },
  { value: "pending", label: "답변 대기" },
  { value: "answered", label: "답변 완료" },
];

function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${y}.${m}.${day}`;
}

export default function AdsInquiryHistory() {
  const navigate = useNavigate();
  const location = useLocation();

  const { name, phone, from, __toast } = location.state || {};

  // console.log(name, phone, from)

  const { bottomSpace } = useFixedLayout();
  const { showToast } = useToast();

  const [period, setPeriod] = useState(PERIOD_OPTIONS[0]);
  const [type, setType] = useState(TYPE_OPTIONS[0]);
  const [sheetMode, setSheetMode] = useState(null); // 'period' | 'type' | null
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [loading, setLoading] = useState(false);  

  // 토스트
  useEffect(() => {
    if (__toast?.key !== "inquiry_registered") return;

    showToast(__toast.msg || "등록되었습니다", {
      placement: "bottom",
      bottomOffset: "8px",
    });
    navigate(".", { replace: true, state: { ...location.state, __toast: null } });
  }, [__toast, navigate, showToast, location.state]);

  // 문의 리스트 불러오기 (기간/종류 변경 시)
  useEffect(() => {
    const fetchList = async () => {
      setLoading(true);

      const payload = {
        user_id : Number(localStorage.getItem("user_id")),
        name: name || undefined,
        phone: phone || undefined,
      }

      try {
        const res = await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/help/list/app`, 
          payload
        );

        let rows = res.data || [];

        // 기간 필터
        const now = new Date();
        const since = new Date(now);

        if (period.value === "1m") {
          since.setMonth(now.getMonth() - 1);
        } else if (period.value === "3m") {
          since.setMonth(now.getMonth() - 3);
        } else if (period.value === "6m") {
          since.setMonth(now.getMonth() - 6);
        }

        rows = rows.filter((item) => {
          if (!item.created_at) return false;
          const created = new Date(item.created_at);
          return !isNaN(created) && created >= since;
        });

        // 상태 필터
        if (type.value !== "all") {
          rows = rows.filter((item) => item.status === type.value);
        }

        setItems(rows);
      } catch (e) {
        console.error("문의 리스트 조회 실패", e);
      } finally {
        setLoading(false);
      }
    };

    fetchList();
  }, [name, phone, period.value, type.value]);

  const handleToggleItem = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const handleSelectPeriod = (opt) => {
    setPeriod(opt);
    setSheetMode(null);
  };

  const handleSelectType = (opt) => {
    setType(opt);
    setSheetMode(null);
  };

  const selectedTypeLabel = TYPE_OPTIONS.find(
    (t) => t.value === type.value
  )?.label;

  const handleHome = () => {
    navigate("/ads/main");
  }

  const goInquiry = () => {
    navigate("/ads/inquiry", { state: { name, phone, from } });
  }


  return (
    <div className="flex flex-col h-dvh bg-surface-light-white">
      {/* 상단 헤더 */}
      <HeaderIconLR
        title="나의 문의 내역"
        leftIcon={left}
        onLeftClick={goInquiry}
        rightIcon={home}
        onRightClick={handleHome}
      />

      {/* 본문 영역 */}
      <div
        className="flex-1 flex flex-col px-[16px] pt-[12px]"
        style={{ paddingBottom: bottomSpace }}
      >
        {/* 상단 타이틀 & 필터 바 */}
        <div className="flex items-center justify-between pb-[16px]">
          <div className="flex flex-col">
            <span className="text-t2 text-text-subtle">
              문의 내역 {items.length}
            </span>
          </div>

          <div className="flex items-center gap-[8px]">
            <button
              type="button"
              onClick={() => setSheetMode("period")}
              className="flex items-center px-[10px] py-[6px]"
            >
              <span className="text-b1 text-text-default">
                {period.label}
              </span>
              <img
                src={chevronDown}
                alt="기간 선택"
              />
            </button>

            {/* 문의 종류 */}
            <button
              type="button"
              onClick={() => setSheetMode("type")}
              className="flex items-center px-[10px] py-[6px]"
            >
              <span className="text-b1 text-text-default">
                {selectedTypeLabel}
              </span>
              <img
                src={chevronDown}
                alt="문의 종류 선택"
              />
            </button>
          </div>
        </div>

        {/* 리스트 영역 */}
        <div className="flex-1 overflow-y-auto pt-[12px] pb-[8px]">
          {loading && (
            <div className="w-full py-[32px] text-center text-c2 text-text-subtler">
              불러오는 중입니다...
            </div>
          )}

          {!loading && items.length === 0 && (
            <div className="w-full py-[32px] text-center text-c2 text-text-subtler">
              조회된 문의 내역이 없습니다.
            </div>
          )}

          <div className="flex flex-col gap-[8px]">
            {items.map((item) => {
              const isOpen = openId === item.id;
              const statusLabel =
                item.status === "pending"
                  ? "답변 대기"
                  : "답변 완료";

              const attachments = [
                item.attachment1,
                item.attachment2,
                item.attachment3,
              ].filter(Boolean)

              const getImageSrc = (rawPath) => {
                if (!rawPath) return "";

                // 절대 URL이면 그대로 사용
                if (rawPath.startsWith("http")) return rawPath;

                // 1) 백슬래시 → 슬래시
                let path = rawPath.replace(/\\/g, "/");
                path = path.replace(/^\.{1,2}\//, ""); // "../uploads/..." → "uploads/..."
                path = path.replace(/^\.{1,2}\/?uploads/, "uploads"); // 안전하게 한 번 더
                path = path.replace(/^\/?app\/uploads/, "uploads");
                if (!path.startsWith("/")) {
                  path = "/" + path;
                }

                // 최종 URL: https://wizmarket.ai + /uploads/...
                return `${IMAGE_BASE}${path}`;
              };

              return (
                <div
                  key={item.id}
                  className="w-full px-[16px] py-[12px] bg-surface-light-white layered border-[1px] border-border-subtle rounded-[8px]"
                >
                  <div className="flex items-center justify-between pb-[8px]">
                    <div className="flex items-center gap-[8px]">
                      <span
                        className={`text-c1 ${item.status === "pending"
                          ? "text-text-default"
                          : "text-text-primary"
                          }`}
                      >
                        {statusLabel}
                      </span>
                      <span className="text-c2 text-text-subtler">
                        ∙ {item.category}
                      </span>
                    </div>
                  </div>

                  {/* 제목 / 내용 */}
                  <div className="pb-[8px]">
                    <button
                      type="button"
                      onClick={() => handleToggleItem(item.id)}
                      className="w-full flex items-center justify-between pb-[4px]"
                    >
                      <span className={`text-t4 text-text-default text-left
                         ${!isOpen ? "overflow-hidden whitespace-nowrap text-ellipsis" : ""}`}>
                        {item.title}
                      </span>
                      <img
                        src={isOpen ? chevronUp : chevronDown}
                        alt={isOpen ? "접기" : "펼치기"}
                      />
                    </button>


                    {isOpen && (
                      <>
                        <p className="text-c2 text-text-subtler leading-[1.5]">{item.content}</p>
                        {/* 첨부 이미지 (있을 때만) */}
                        {attachments.length > 0 && (
                          <div className="flex pt-[8px] pb-[4px] gap-[8px]">
                            {attachments.slice(0, 3).map((filePath, i) => (
                              <div
                                key={i}
                                className="w-[90px] h-[90px] rounded-[16px] overflow-hidden border-[1px] border-border-default"
                              >
                                <img
                                  src={getImageSrc(filePath)}
                                  alt={`첨부이미지 ${i + 1}`}
                                  className="w-full h-full object-cover"
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                  </div>


                  {/* 날짜 */}
                  <div className="pt-[8px]">
                    <span className="text-c2 text-text-subtler">
                      {formatDate(item.created_at)}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* 필터 바텀시트 */}
      {sheetMode && (
        <BottomSheetFilter
          mode={sheetMode}
          period={period}
          type={type}
          onClose={() => setSheetMode(null)}
          onSelectPeriod={handleSelectPeriod}
          onSelectType={handleSelectType}
        />
      )}
    </div>
  );
}

/** 기간/문의종류 선택용 바텀시트 */
function BottomSheetFilter({
  mode,
  period,
  type,
  onClose,
  onSelectPeriod,
  onSelectType,
}) {
  const options = mode === "period" ? PERIOD_OPTIONS : TYPE_OPTIONS;
  // const selectedValue =
  //   mode === "period" ? period.value : type.value;

  return (
    <Bottom
      isOpen={true}
      onClose={onClose}
      title={mode === "period" ? "기간" : "답변 여부"}
      height="h-64"
    >
      <div className="flex flex-col gap-[22px]">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() =>
              mode === "period"
                ? onSelectPeriod(opt)
                : onSelectType(opt)
            }
            className="w-full rounded-[12px] bg-surface-light-white text-left text-b1 text-text-default"
          >
            {opt.label}
          </button>
        ))}
      </div>
    </Bottom>
  );
}
